var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSilverBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6309 15.45H19.0234L27.0159 0H20.6234L12.6309 15.45Z",
    fill: "#006CA2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6257 7.7251L13.4307 13.9051L14.2307 15.4501H19.0232L19.8232 13.9051L16.6257 7.7251Z",
    fill: "#101010"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5364 19.18H13.1414V15.45H19.5339V19.18H19.5364ZM19.5364 13.8525H13.1414C12.2589 13.8525 11.5439 14.5675 11.5439 15.45V19.18C11.5439 20.0625 12.2589 20.7775 13.1414 20.7775H19.5339C20.4164 20.7775 21.1314 20.0625 21.1314 19.18V15.45C21.132 15.2403 21.0911 15.0326 21.0112 14.8387C20.9312 14.6448 20.8138 14.4686 20.6656 14.3201C20.5174 14.1717 20.3414 14.054 20.1476 13.9738C19.9539 13.8935 19.7462 13.8523 19.5364 13.8525Z",
    fill: "#CECED2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3307 23.9752C24.3307 28.3902 20.7532 31.9677 16.3382 31.9677C11.9257 31.9677 8.3457 28.3902 8.3457 23.9752C8.3457 19.5602 11.9232 15.9827 16.3382 15.9827C20.7532 15.9827 24.3307 19.5627 24.3307 23.9752Z",
    fill: "#CECED2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9812 22.03C10.8762 22.03 10.7712 22.01 10.6712 21.965C10.2862 21.8 10.1012 21.3525 10.2512 20.9625C10.2537 20.9575 10.2562 20.95 10.2562 20.945C10.2587 20.9325 10.2587 20.935 10.2662 20.925C10.6158 20.0939 11.1578 19.3577 11.8476 18.777C12.5374 18.1963 13.3552 17.7878 14.2337 17.585C14.3212 17.565 14.4137 17.6075 14.4537 17.69C14.4937 17.7725 14.4712 17.87 14.3987 17.9275C13.2312 18.855 12.2987 20.105 11.7037 21.5425C11.7037 21.545 11.7012 21.5475 11.7012 21.5475C11.7012 21.55 11.7012 21.55 11.6987 21.5525C11.6162 21.745 11.4637 21.8925 11.2687 21.97C11.1787 22.0125 11.0787 22.03 10.9812 22.03Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5588 15.45H13.1638L5.17383 0H11.5663L19.5588 15.45Z",
    fill: "#006CA2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverBadge);
export default __webpack_public_path__ + "static/media/silver-badge.66e30534a56d0c63f5edc695cb498a44.svg";
export { ForwardRef as ReactComponent };